import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import View from "@pathwright/ui/src/components/ui/View"
import { WithCSS } from "@pathwright/ui/src/components/utils/styles"
import PropTypes from "prop-types"
import { css } from "styled-components"
import withLesson from "../lesson/withLesson"
import PathStepsAnimator from "./PathStepsAnimator"

export const PathSteps = ({
  lesson: queryLesson,
  propsLesson,
  expand,
  total,
  onEnterStep
}) => {
  const lesson = propsLesson || queryLesson

  return (
    <View>
      {lesson && lesson.items.length > 0 && (
        <PathStepsAnimator
          expand={expand}
          steps={lesson.items}
          onEnterStep={onEnterStep}
        />
      )}
      <WithCSS
        as={View}
        css={css`
          padding: 5px 0;
          text-align: center;
          border-radius: 0 0 10px 10px;
        `}
      >
        <Text.Meta>
          <Pathicon icon={`chevron-${expand ? "up" : "down"}`} />{" "}
          {expand ? "Hide" : "Show"} {total} steps
        </Text.Meta>
      </WithCSS>
    </View>
  )
}

PathSteps.displayName = "PathSteps"

PathSteps.propTypes = {
  // can be used instead of queried lesson
  propsLesson: PropTypes.object,
  // props for querying
  lessonSourceId: PropTypes.number,
  pathId: PropTypes.number.isRequired,
  schoolId: PropTypes.number.isRequired
}

// withLesson queries the Path (see withPath)
// we'll allow passing propsLesson to skip queries
const PathStepsContainer = ({ propsLesson, ...rest }) => {
  if (propsLesson) {
    return <PathSteps lesson={propsLesson} {...rest} />
  }

  return withLesson(PathSteps)
}

export default PathStepsContainer
